import { useState } from 'react'
import { type ResolvedBranchNode } from '@/lib/branchTypes'

type UseBranchChoiceHoverPreviewArgs = {
  nextNodeId: string | null
  nodes: Record<string, ResolvedBranchNode>
  onBranchHover?: (targetId: string | null) => void
}

// Tracks which option is being hovered so we can show its preview while leaving the committed path untouched.
export const useBranchChoiceHoverPreview = ({
  nextNodeId,
  nodes,
  onBranchHover,
}: UseBranchChoiceHoverPreviewArgs) => {
  const [hoveredTargetId, setHoveredTargetId] = useState<string | null>(null)
  const [previewTargetId, setPreviewTargetId] = useState<string | null>(null)
  const handleBranchHover = (targetId: string | null) => {
    setHoveredTargetId(targetId)
    if (targetId !== null) setPreviewTargetId(targetId)
    onBranchHover?.(targetId)
  }
  const clearPreview = () => setPreviewTargetId(null)
  const previewNode =
    previewTargetId && previewTargetId !== nextNodeId
      ? nodes[previewTargetId] ?? null
      : null
  return {
    hoveredTargetId,
    previewTargetId,
    previewNode,
    handleBranchHover,
    clearPreview,
  }
}
